import PubSub from 'pubsub-js';
import axios from "axios";

const endpoint = '/api/featuredcontent';
const storeName = Symbol('Content Centre Navigate');
let abortController;

/**
 * Makes a request to the Content Centre endpoint, and publishes the response data to the store.
 * @param {string} params.id The id/tag of the item to navigate to.
 * @param {string} params.page The page number to fetch.
 * @param {string} params.pageSize The size of a page to fetch.
 * @param {object} filters A set of key/value pairs to filter by. Values may be strings or arrays.
 * @param {string} sort A key to sort results by.
 */
export async function navigate(params, filters, sort) {
  try {
    // Abort any pending request
    if (abortController) {
      abortController.abort();
    }

    abortController = new AbortController();
    const endpointUrl = new URL(endpoint, location.href);
    const querystring = new URLSearchParams();
    if (filters) {
      Object.entries(filters).forEach(([name, value]) => querystring.set(name, value));
    }
    if (sort) {
      querystring.set('sort', sort);
    }
    endpointUrl.search = querystring.toString();

    const { id, page, pageSize } = params;
    const response = await axios.post(
      endpointUrl.toString(),
      { id, page, pageSize },
      { signal: abortController.signal }
    );
    if (response.data) {
      PubSub.publish(storeName, { data: response.data, ...params });
    }
  }
  catch(err) {
    if (err.message !== 'canceled') {
      throw new Error(err);
    }
    // TODO: What do we do when this spews out an error..?
  }
  finally {
    abortController = undefined;
  }
}

/**
 * Subscribe a callback to fetching Content Centre items.
 * @param {Function} callback The function to call when the store changes. Parameter are the API response data, and any params & arguments passed to `navigate()`.
 * @returns {string} A token that can be used to unsubscribe this callback.
 */
export function subscribe(callback) {
  return PubSub.subscribe(storeName, (_key, { data, ...args }) => callback(data, args));
}

/**
 * Unsubscribes a callback from fetching Content Centre items, using a token returned by `subscribe()`.
 * @param {string} token The token returned by `subscribe()`.
 */
export function unsubscribe(token) {
  PubSub.unsubscribe(storeName, token);
}